const data = [0, 0.11, -0.13, 0.000008, 0.89];
const ZERO_ADJ = 1e-10;
const AMOUNT_NORMALIZATION_THRESHOLD = 100;
const VOLUME_NORMALIZATION_THRESHOLD = 20;
const LOG_ADJ = 1;

function logNorm(dataArray, logBase = 10) {
  return dataArray.map((item) => {
    return Math.log(item + LOG_ADJ) / Math.log(logBase);
  });
}

function minMaxNorm(dataArray) {
  const maxValue = Math.max(...dataArray);
  const minValue = Math.min(...dataArray);
  return dataArray.map((item) => {
    return (item - minValue) / (maxValue - minValue);
  });
}

function maxNorm(dataArray) {
  const maxValue = Math.max(...dataArray);
  return dataArray.map((item) => {
    return (item / maxValue) * 100;
  });
}

export const normalizationAmount = (dataArray) => {
  const maxValue = Math.max(...dataArray);
  const minValue = Math.min(...dataArray);
  let dataArrayUse = [];
  if (minValue <= 0) {
    const dataArrayNew = dataArray.map((item) => {
      return item - minValue;
    });
    dataArrayUse = dataArrayNew;
  } else {
    dataArrayUse = dataArray;
  }
  const maxValueUse = Math.max(...dataArrayUse);
  const minValueUse = Math.min(...dataArrayUse);

  if (
    maxValueUse > AMOUNT_NORMALIZATION_THRESHOLD &&
    maxValueUse / Math.abs(minValueUse + ZERO_ADJ) > 10
  ) {
    const normalizedArray = logNorm(dataArrayUse, 10);
    return maxNorm(normalizedArray);
  } else if (
    maxValueUse > VOLUME_NORMALIZATION_THRESHOLD &&
    maxValueUse / Math.abs(minValueUse + ZERO_ADJ) > 5
  ) {
    const normalizedArray = logNorm(dataArrayUse, 2);
    return maxNorm(normalizedArray);
  } else {
    return maxNorm(dataArrayUse);
  }
};

//Normalising the alert score for the off-mode
export const normalizeAlertScore = (alertScore) => {
  if (alertScore >= 100) {
    return 100;
  } else if (alertScore <= 0) {
    return 0;
  }
  return alertScore;
};
